import React from 'react';
import { IconCardFilled, IconDangerFilled, IconUserAddFilled } from '@carnica/graphics';
import { getNotificationIconType } from "./utils";
import { NOTIFICATION_TYPES } from "./constants";
export var NotificationIcon = function NotificationIcon(_ref) {
  var type = _ref.type;
  var notificationType = getNotificationIconType(type);
  switch (notificationType) {
    case NOTIFICATION_TYPES.payments:
      return /*#__PURE__*/React.createElement(IconCardFilled, {
        color: "primary",
        "data-t-id": "components-NotificationIcon"
      });
    case NOTIFICATION_TYPES.invites:
      return /*#__PURE__*/React.createElement(IconUserAddFilled, {
        color: "primary"
      });
    case NOTIFICATION_TYPES.warnings:
      return /*#__PURE__*/React.createElement(IconDangerFilled, null);
    default:
      return /*#__PURE__*/React.createElement(IconDangerFilled, null);
  }
};